import React from 'react'
import InjectionMouldingContent from './injectionMouldingContent';
import get from 'lodash/get';
import CncContent from './cncContent';
import ExtrutionContent from './extrutionContent';
import PunchPressContent from './punchPressContent';

const DayGraphContentContainer = ({ selectedTemplate, filter, data }) => {
      const templateType = get(filter, "templateType");
      switch (templateType) {
            case 1:
                  return <InjectionMouldingContent selectedTemplate={selectedTemplate} filter={filter} data={data} />
            case 2:
                  return <ExtrutionContent selectedTemplate={selectedTemplate} filter={filter} data={data} />
            case 3:
                  return <PunchPressContent selectedTemplate={selectedTemplate} filter={filter} data={data} />
            case 4:
                  return <CncContent selectedTemplate={selectedTemplate} filter={filter} data={data} />
      }
}

export default DayGraphContentContainer